/**
 * 表示用サイト名（TK-057）。内部名 `r18-jigsaw-puzzles` は UI に出さない。
 * ランタイム（ヘッダ）とビルド（選択画面の見出し・`<title>` の接尾辞）で共有する。
 * DOM に依存しないため、ビルド側（tsconfig.node.json）からも import できる。
 */
export const SITE_NAME = 'R18ジグソーパズル';
